import './Contacts.scss';

import { FaLinkedinIn, FaFacebookF } from "react-icons/fa";
import { BsInstagram, BsTelephoneFill } from "react-icons/bs";
import { IoIosMail } from "react-icons/io";

const Contacts = (props) => {

    return (
        <>
            <div className='ContactsCon'>
                <div className='Contacts'>
                    <i className='iconBtn' onClick={() => window.open('https://www.linkedin.com/company/soft-machine/')}>
                        <FaLinkedinIn />
                    </i>
                    <i className='iconBtn' onClick={() => window.open('https://www.instagram.com/_softmachine_/')}>
                        <BsInstagram />
                    </i>
                    <i className='iconBtn' onClick={() => window.open('https://www.facebook.com/SoftMachine30')}>
                        <FaFacebookF />
                    </i>
                    <i className='iconBtn' onClick={() => window.open('mailto:info@softmachine.co')}>
                        <IoIosMail />
                    </i>
                    <i className='iconBtn' onClick={() => window.open('tel:+96176888468')}>
                        <BsTelephoneFill />
                    </i>
                </div>
                {/* Copyright © 2022 SoftMachine. All rights reserved. */}
            </div>
        </>
    );
};

export default Contacts;